<template>
  <div>
    <OrderAccount
      :orderId="orderData.id"
      @orderAccountCancel="handleOrderAccountCancel"
    />
  </div>
</template>
<script>
import OrderAccount from '@/bizComponents/OrderAccount'

export default {
  inject: ['orderData'],
  components: {
    OrderAccount,
  },
  methods: {
    handleOrderAccountCancel() {
      this.$refreshBack(false)
    },
  },
}
</script>
